// 判断当前联网状态
export function isOnline() {
  return window.navigator.onLine;
}
